import React from 'react'
import { useTranslation } from 'react-i18next'
import { BsArrowUpShort } from 'react-icons/bs'

const ODataTable = ({
  data = [],
  columns = [],
  loading = false,
  pagination = null,
  onPageChange,
  sort = null,
  onSortChange,
  emptyMessage = 'No records found'
}) => {
  const { t } = useTranslation()

  const handleSort = (columnKey) => {
    if (!onSortChange || !columnKey) return
    
    const newSortType = sort?.sortKey === columnKey && sort?.sortType === 'asc' ? 'desc' : 'asc'
    onSortChange({
      sortKey: columnKey,
      sortType: newSortType
    })
  }

  const getSortIcon = (columnKey) => {
    if (!sort || sort.sortKey !== columnKey) return null
    
    return (
      <BsArrowUpShort 
        className={`w-4 h-4 ${sort.sortType === 'desc' ? 'rotate-180' : ''}`} 
      />
    )
  }

  return (
    <div className='p-3'>
      <div className='overflow-x-auto relative border'>
        <table className='w-full text-left text-xs text-[#A5A5A5] dark:text-gray-400'>
          <thead className='text-xs text-gray-900 border border-[#E1E6EE] bg-[#E1E6EE] dark:bg-gray-700 dark:text-gray-400'>
            <tr>
              <th scope='col' className='px-6 py-3'>
                #
              </th>
              {columns.map((column, index) => (
                <th
                  key={index}
                  scope='col'
                  className={`px-6 py-3 ${column.align === 'center' ? 'text-center' : ''} ${column.sortable ? 'cursor-pointer' : ''}`}
                  onClick={() => column.sortable && handleSort(column.key)}
                >
                  <div className={`flex items-center gap-1 ${column.align === 'center' ? 'justify-center' : 'justify-start'}`}>
                    <span>{column.title}</span>
                    {column.sortable && getSortIcon(column.key)}
                  </div>
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {loading ? (
              <tr>
                <td colSpan={columns.length + 1} className='py-8 text-center'>
                  <div className='flex justify-center'>
                    <div className='animate-spin rounded-full h-8 w-8 border-b-2 border-blue-500'></div>
                  </div>
                </td>
              </tr>
            ) : data.length > 0 ? (
              data.map((row, index) => (
                <tr key={row.id || index} className='bg-white border-b border-[#E1E6EE] dark:bg-gray-800 dark:border-gray-700'>
                  <td className='border-l px-6 py-3 font-medium text-gray-900 dark:text-white'>
                    {pagination ?
                      (pagination.page - 1) * (pagination.limit || 10) + index + 1 :
                      index + 1
                    }
                  </td>
                  {columns.map((column, colIndex) => (
                    <td
                      key={colIndex}
                      className={`border-l px-6 py-3 ${column.align === 'center' ? 'text-center' : ''}`}
                    >
                      {column.render ? column.render(row, index) : row[column.key]}
                    </td>
                  ))}
                </tr>
              ))
            ) : (
              <tr className='bg-white text-center border-b dark:bg-gray-800 dark:border-gray-700'>
                <td className='px-6 py-3' colSpan={columns.length + 1}>
                  {t(emptyMessage)}
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  )
}

export default ODataTable
